<template>
  <div class="iconContainer">
    <TooltipIcon
      icon="IconPreferences"
      iconName="Preferences"
      viewBox="0 0 64 64"
      boxHeight="40"
      boxWidth="40"
      iconWidth="20"
      iconHeight="20"
      iconColor="#222"
      borderRadius="360"
      defaultText="Customize your preferences"
      activeText="Syncing calendar..."
      styleOne=""
      @triggerTooltipFunction="togglePreferences"
    />
    <!-- <div class="newDot">new</div> -->
  </div>
</template>

<script>
import TooltipIcon from "./TooltipIcon";

export default {
  name: "PreferencesButton",
  components: {
    TooltipIcon,
  },
  methods: {
    togglePreferences() {
      this.$store.commit("cofocusPreferences/SET_SETTINGS_TAB", "Preferences");
      this.$store.commit("cofocusPreferences/TOGGLE_SETTINGS");
    },
  },
};
</script>
<style scoped>
.iconContainer {
  position: relative;
}
.newDot {
  position: absolute;
  top: 1px;
  right: 0;
  background-color: white;
  border-radius: 360px;
  padding: 2px 4px;
  color: blue;
  font-size: 10px;
  font-weight: 700;
}
</style>